import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);

const createCapitalValidation = Yup.object().shape({
  account_id: Yup.string().required(),
  figure_id: Yup.string().required()
});

export default createCapitalValidation;
